<template>
  <div class="flex flex-wrap">
    <div class="w-full">
      <div class="relative inline-flex align-middle w-full rounded-lg">
        <div
          class="bg-white text-base z-50 float-left list-none text-left rounded w-full"
          v-bind:class="{
            hidden: !dropdownPopoverShow,
            block: dropdownPopoverShow,
          }"
        >
          <div class="divide-y" v-if="notifications.length">
            <div
              v-for="n in notifications"
              :key="n.id"
              class="hover:bg-blue-lightest py-1"
              :class="{ 'opacity-50': n.is_active == INACTIVE }"
            >
              <div v-if="n.type != notificationType">
                <NotificationList
                  :title="n.data && n.data.title"
                  :body="n.data && n.data.body"
                  :action="n.data && n.data.action"
                  :thumbnail_url="n.thumbnail_url"
                  :type="n.type"
                  :user="userType"
                />
              </div>
            </div>
          </div>
          <div class="text-center" v-if="!isNotification">
            No unread notification
          </div>
          <div v-if="userType == 'Trainer'">
            <router-link
              :to="{ name: 'TrainerNotification' }"
              class="text-xs px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-green-light text-center"
            >
              <span @click="handleClose"> See All </span>
            </router-link>
          </div>
          <div v-if="userType == 'User'">
            <router-link
              :to="{ name: 'UserNotification' }"
              class="text-xs px-4 font-normal block w-full whitespace-no-wrap bg-transparent text-green-light text-center"
            >
              <span @click="handleClose"> See All </span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationList from "@/components/notification/NotificationList";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NotificationDropdown",
  components: {
    NotificationList,
  },
  props: {
    userType: {
      type: String,
    },
  },
  data() {
    return {
      dropdownPopoverShow: true,
      notificationType: "sendMessage",
      isNotification: false,
      INACTIVE: 0,
    };
  },
  computed: {
    ...mapGetters(["notifications"]),
  },
  methods: {
    ...mapActions(["getNotifications"]),

    handleClose() {
      this.$emit("onClose");
    },
  },
  async created() {
    if (this.getToken()) {
      await this.getNotifications();
    }
    for (let i in this.notifications) {
      if (this.notifications[i].type != this.notificationType) {
        this.isNotification = true;
      }
    }
  },
};
</script>